<div class="col p-0">
    <div class="wardSelectInstitution">
        <div class="institution-name">
            <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'>
                {{selectedInstitutionName | labelSanitizer}}
            </p>
            <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName() | labelSanitizer}}</p>
        </div>
    </div>

    <div class="col-12 static-card">
        <bd-light-table #grid
        [gridData]="gridData || [] | search:searchText"
        [pageInfo]="pageInfo" [fields]="fields" [actions]="actionItems"
        [actionsLast]="true"
        [addNewRow]="true"
        [addNewRowButton]="true"
        [customButton]="importWebkessButton"
        [migrationButton]="showWardMappingButton ? mapMigratedWardsButton : false"
        [gridEditable]="true"
        [classTable]="'wards'"
        (handlerData)="handlerData($event)"
        (removeLink)="removeLink($event)"
        (addNewRowCallback)="addNew()">
        </bd-light-table>
    </div>

</div>

<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.WARDS' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #unlinkModal>
    <div class="modal-header bhp-modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body bhp-modal-body" data-simplebar>
        <p>{{ translationKeys.ErrorMessages.ConfirmUnlinkWebkess | translate }}</p>
    </div>
    <div class="modal-footer bhp-modal-footer">
        <!--<div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'INSTITUTION_MANAGEMENT.NO' |
                        translate }}</button>
                    <button (click)="unlink();modalRef.hide()" class="btn-bd-empty ml-3">{{ 'INSTITUTION_MANAGEMENT.YES' |
                        translate }}</button>
                </div>
            </div>
        </div>-->
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="unlink();modalRef.hide()" class="btn-bd-empty ml-3">{{ 'CONFIGURE.UNLINKWARD' | translate }}</button>
    </div>
</ng-template>

<ng-template #template>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate
            }}</h5>
        <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar class="change-lang">
        <div [formGroup]="mygroup" class="col-12">
            <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
                <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns"
                    *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input"
                    id={{Institutions.institution.institutionID}}>
                <label class="form-check-label"
                    for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName |
                    labelSanitizer}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 my-3">
                    <button type="button" class="btn-bd-empty ml-3"
                        (click)="onInstitutionChange(mygroup.value.selectedIns);modalRef.hide();">{{
                        translationKeys.Authorization.Done | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #confirmMapWardsModal>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">Migrated Wards</h5>
        <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p class="lead">
            {{'Wards migrated from Observe need verification' | translate}}
        </p>
        <p class="lead font-weight-bold">
            {{'Select the shortlisted wards' | translate}}
        </p>

    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{translationKeys.Button.Cancel |
                        translate}}</button>
                    <button (click)="mapMigratedWards($event);modalRef.hide();"
                    class="btn-bd-empty ml-3">{{translationKeys.Button.Ok | translate}}</button>
                </div>
            </div>
        </div>
    </div>

</ng-template>

<ng-template #confirmModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'WEBKESS_INTEGRATION.ASSIGN_DEPARTMENTS_TO_WARDS_NOTICE' | translate }} </p>
        <p> {{ 'WEBKESS_INTEGRATION.IMPORT.WAIT_FOR_COMPLETION' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ translationKeys.Button.Cancel | translate}}</button>
            <button (click)="importStations($event);modalRef.hide();" class="btn btn-continue-bordered-bd">{{ 'SOP_OBSERVATION.CONTINUE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #cancelmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'LAYOUT_MODULE.STAY' | translate }}</button>
            <button (click)="cancel();modalRef.hide()" class="btn btn-continue-bordered-bd">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
        </div>
    </div>

    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
</ng-template>
